site.calendarFilter = {
	defaultCategorie: null,
	currentCategorie: null,
	currentMonth: null,

	init: function () {
		var $container = $('.calFilter + .eventList');
		//var $conCategorie = $('.calFilter + .event__single');
		if (!$container) return false;

		site.calendarFilter.defaultCategorie = $('select#categorie option:first-child').val();

		$('img.responsive').responsiveImg({threshold: $(window).height()});
		$(window).load(function() {
			$container.isotope({
				itemSelector: '.event__single',
				layoutMode: 'vertical',
				hiddenStyle: {
					opacity: 0
				},
				visibleStyle: {
					opacity: 1
				}
			});

		});

		$(window).bind("hashchange", function(e) {
			var b = location.hash;

			if (b) {
				b = b.substr(1, b.length);
				var hashCategorie = null,
					hashMonth = null;

				if (b.indexOf('|') > 0) {
					var split = b.split('|');
					hashCategorie = split[0];
					hashMonth = split[1];
					$('.' + hashMonth).addClass('selected');
					document.getElementById("categorie").value = hashCategorie;
					site.calendarFilter.currentMonth = hashMonth;
					site.calendarFilter.currentCategorie = hashCategorie;
				}
				else {
					if (b.indexOf('-') < 0 && b.indexOf('all') < 0) {
						hashMonth = b;
						$('.' + hashMonth).addClass('selected');
						site.calendarFilter.currentMonth = hashMonth;
					}
					else {
						hashCategorie = b;
						document.getElementById("categorie").value = hashCategorie;
						site.calendarFilter.currentCategorie = hashCategorie;
					}
				}

				var $eventList = $('.eventList');


				if (hashMonth && hashCategorie === 'all') {
					$eventList.isotope({filter: '.' + hashMonth});
				}
				else if (hashMonth && hashCategorie) {
					$eventList.isotope({filter: '.' + hashMonth + '.' + hashCategorie});
				}
				else if (hashMonth && !hashCategorie) {
					$eventList.isotope({filter: '.' + hashMonth});
				}
				else if (!hashMonth && hashCategorie !== 'all') {
					$eventList.isotope({filter:'.' + hashCategorie});
				}
				else if (hashMonth === 'seeAll' && hashCategorie) {
					$eventList.isotope({filter: '.' + hashCategorie})
				}
				else {
					$eventList.isotope({filter: '*'});
				}

			}
			else {
				$('.eventList').isotope({filter: '*'})
			}

		});
		$(window).trigger("hashchange");


		$('.months').on( 'click', 'a', function(e) {
			e.preventDefault();
			site.calendarFilter.currentMonth = $(this).data('month');

			if ($(this).hasClass('selected')) {
				$(this).removeClass('selected');
				site.calendarFilter.currentMonth = null;
			}
			else {
				$(this).siblings().removeClass('selected');
				$(this).toggleClass('selected');
				if ($(this).hasClass('seeAll')) {
					site.calendarFilter.currentMonth = null;
				} else {
					site.calendarFilter.currentMonth = $(this).data('month');
				}

			}

			site.calendarFilter.setHash();

		});

		$('#categorie').on('change', function(e) {
			e.preventDefault();
			site.calendarFilter.currentCategorie = $('#categorie option:selected').val();

			site.calendarFilter.setHash();
		})

	},

	setHash: function () {

		if (site.calendarFilter.currentCategorie && site.calendarFilter.currentMonth) {
			var hash = '#' + site.calendarFilter.currentCategorie + '|' + site.calendarFilter.currentMonth;
			window.location.hash = hash;
		}
		else if (site.calendarFilter.currentCategorie && site.calendarFilter.currentMonth === null) {
			var hash = '#' + site.calendarFilter.currentCategorie;
			window.location.hash = hash;
		}
		else if (!site.calendarFilter.currentCategorie && !site.calendarFilter.currentMonth ) {
			var hash = '';
			window.location.hash = hash;
		}
		else if (!site.calendarFilter.currentCategorie && site.calendarFilter.currentMonth) {
			var hash = site.calendarFilter.currentMonth;
			window.location.hash = hash;
		}
		else if (!site.calendarFilter.currentCategorie && site.calendarFilter.currentMonth === 'seeAll') {
			var hash = 'all';
			window.location.hash = hash;
		}
	}
};
